import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {RegisterComponent} from './register/register.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {AcceptPrivacyComponent} from './accept-privacy/accept-privacy.component';


const routes: Routes = [
  {
    path: 'registration/:token', loadChildren: () => import('./registration/registration.module').then(m => m.RegistrationModule),
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  // {path: 'reset-password/:idUser/:token', component: ResetPasswordComponent},
  {path: 'accept-privacy', component: AcceptPrivacyComponent},
  {path: 'reset-password/:idUser/:token', component: ResetPasswordComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true, scrollPositionRestoration: 'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
